var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.66666C10.7521 2.66666 6.3147 6.55163 5.6211 11.7536L4.41429 20.8047C4.09457 23.2026 5.96005 25.3333 8.3792 25.3333H9.80489C11.0104 27.6639 13.2819 29.3333 16 29.3333C18.7182 29.3333 20.9897 27.6639 22.1952 25.3333H23.6209C26.04 25.3333 27.9055 23.2026 27.5858 20.8047L26.379 11.7536C25.6854 6.55164 21.248 2.66666 16 2.66666ZM18.9624 25.3333H13.0377C13.8496 26.183 14.9024 26.6666 16 26.6666C17.0977 26.6666 18.1505 26.183 18.9624 25.3333Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3913a08ff05e1c8bd5d4f76368fee298.svg";
export { ForwardRef as ReactComponent };